var $77ac944da51b7354$exports = {};
document.addEventListener("DOMContentLoaded", function() {
    setTimeout($77ac944da51b7354$var$iniciar, 2500);
});
document.addEventListener("scroll", $77ac944da51b7354$var$initOnEvent);
document.addEventListener("mousemove", $77ac944da51b7354$var$initOnEvent);
document.addEventListener("touchstart", $77ac944da51b7354$var$initOnEvent);
function $77ac944da51b7354$var$initOnEvent(event) {
    $77ac944da51b7354$var$iniciar();
    event.currentTarget.removeEventListener(event.type, $77ac944da51b7354$var$initOnEvent); // remove the event listener that got triggered
}
function $77ac944da51b7354$var$initGtm(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
        "gtm.start": new Date().getTime(),
        event: "gtm.js"
    });
    var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
}
async function $77ac944da51b7354$var$initPixel(f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function() {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
    fbq("init", "294939673456021");
}
function $77ac944da51b7354$var$iniciar() {
    if (window.DidInit) return false;
    window.DidInit = true;
    try {
        $77ac944da51b7354$var$initClarity(window, document, "clarity", "script", "pw0wpz7cce");
    } catch  {
        console.log("Erro no initClarity");
    }
    try {
        $77ac944da51b7354$var$initAnalytics();
    } catch  {
        console.log("Erro no analytics");
    }
    // try {
    //   initPixel(
    //     window,
    //     document,
    //     "script",
    //     "https://connect.facebook.net/en_US/fbevents.js"
    //   );
    //   if (window.location.href.search("/obrigado") > -1) {
    //     console.log("LEAD");
    //     fbq("track", "Lead");
    //   } else {
    //     console.log("VIEW");
    //     fbq("track", "PageView");
    //   }
    // } catch {
    //   console.log("Erro ao iniciar o pixel");
    // }
    try {
        $77ac944da51b7354$var$initTiktok(window, document, "ttq");
        if (window.location.href.search("/obrigado") > -1) {
            ttq.identify({
                email: "<hashed_email_address>",
                phone_number: "<hashed_phone_number>",
                external_id: "<hashed_extenal_id>"
            });
            ttq.track("Subscribe", {});
        } else console.log("VIEW");
    } catch  {
        console.log("Erro no tiktok");
    }
    $77ac944da51b7354$var$initGtm(window, document, "script", "dataLayer", "GTM-WMNBD67Z");
}
function $77ac944da51b7354$var$initAnalytics() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "G-D7FBM50LQ8");
}
function $77ac944da51b7354$var$initTiktok(w, d, t) {
    w.TiktokAnalyticsObject = t;
    var ttq1 = w[t] = w[t] || [];
    ttq1.methods = [
        "page",
        "track",
        "identify",
        "instances",
        "debug",
        "on",
        "off",
        "once",
        "ready",
        "alias",
        "group",
        "enableCookie",
        "disableCookie",
        "holdConsent",
        "revokeConsent",
        "grantConsent"
    ], ttq1.setAndDefer = function(t, e) {
        t[e] = function() {
            t.push([
                e
            ].concat(Array.prototype.slice.call(arguments, 0)));
        };
    };
    for(var i = 0; i < ttq1.methods.length; i++)ttq1.setAndDefer(ttq1, ttq1.methods[i]);
    ttq1.instance = function(t) {
        for(var e = ttq1._i[t] || [], n = 0; n < ttq1.methods.length; n++)ttq1.setAndDefer(e, ttq1.methods[n]);
        return e;
    }, ttq1.load = function(e, n) {
        var r = "https://analytics.tiktok.com/i18n/pixel/events.js", o = n && n.partner;
        ttq1._i = ttq1._i || {}, ttq1._i[e] = [], ttq1._i[e]._u = r, ttq1._t = ttq1._t || {}, ttq1._t[e] = +new Date(), ttq1._o = ttq1._o || {}, ttq1._o[e] = n || {};
        n = document.createElement("script");
        n.type = "text/javascript", n.async = !0, n.src = r + "?sdkid=" + e + "&lib=" + t;
        e = document.getElementsByTagName("script")[0];
        e.parentNode.insertBefore(n, e);
    };
    ttq1.load("CT0DSFBC77U74JDQOD20");
    ttq1.page();
}
function $77ac944da51b7354$var$initClarity(c, l, a, r, i, t, y) {
    c[a] = c[a] || function() {
        (c[a].q = c[a].q || []).push(arguments);
    };
    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
} // add this before event code to all pages where PII data postback is expected and appropriate 


//# sourceMappingURL=index.156354f2.js.map
